import { legacy_createStore as createStore, applyMiddleware, compose } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk';
import rootReducer from './reducers';

const middlewareEnhancer = applyMiddleware(thunkMiddleware);
const composedEnhancers = compose(
  middlewareEnhancer,
);

const store = createStore(rootReducer, composedEnhancers);
export default store;
